// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"177":"home","709":"Cast","756":"Review","816":"Movie"}[chunkId] || chunkId) + "." + {"105":"849e8bd0","177":"f9dbbd4e","640":"9d4db275","709":"5c9cda0f","756":"55785085","816":"26100227"}[chunkId] + ".chunk.js";
};